export { default } from '../Success';



// WEBPACK FOOTER //
// ./src/give/Checkout/Success.js